export default __webpack_public_path__ + "static/media/loader.3bab410e.gif";